<template>
  <li
    class="relative py-5 px-4 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 cursor-default"
    :class="[focused ? 'bg-blue-50' : 'bg-white hover:bg-gray-50']"
    @click="$emit('email-message:focus', emailMessage)"
  >
    <div class="flex justify-between space-x-3">
      <div class="min-w-0 flex-1">
        <p v-if="emailMessage.user" class="text-sm font-medium text-gray-900 truncate">
          {{ emailMessage.user.fullName }}
        </p>
      </div>
      <time
        :datetime="emailMessage.created_at"
        class="flex-shrink-0 whitespace-nowrap text-sm text-gray-500"
        >{{ createdAtFromNow }}</time
      >
    </div>
    <div class="mt-1">
      <p class="line-clamp-2 text-sm text-gray-600">
        {{ emailMessage.subject || 'Subject N/A' }}
      </p>
    </div>
    <div v-if="canEditOrDelete" class="mt-3 flex space-x-2">
      <BaseButton primary outline small @click.stop="handleEmailMessageEdit"> Edit </BaseButton>
      <BaseButton ghost small @click.stop="handleEmailMessageDelete"> Delete </BaseButton>
    </div>
  </li>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    emailMessage: {
      type: Object,
      required: true,
    },
    focused: Boolean,
  },
  computed: {
    createdAt() {
      return moment.utc(this.emailMessage.created_at).local();
    },
    createdAtShort() {
      return this.createdAt.format('DD-MM-YYYY');
    },
    createdAtFromNow() {
      return this.createdAt.fromNow();
    },
    canEditOrDelete() {
      if (typeof this.emailMessage.tracking_logs_count !== 'number') {
        return false;
      }

      return this.emailMessage.tracking_logs_count === 0;
    },
  },
  methods: {
    handleEmailMessageEdit() {
      if (!this.canEditOrDelete) {
        return;
      }

      this.$emit('email-message:edit', this.emailMessage);
    },
    handleEmailMessageDelete() {
      if (!this.canEditOrDelete) {
        return;
      }

      this.$emit('email-message:delete', this.emailMessage);
    },
  },
};
</script>
